import React from 'react'
import type { Icon } from 'shared/utils'

const Search = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'search',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g
                transform="translate(3 3)"
                stroke={color}
                strokeWidth={1.5}
                fill="none"
                fillRule="evenodd">
                <ellipse cx={8} cy={8.5} rx={7.25} ry={7.75} />
                <path strokeLinecap="round" d="M13.5 13.5l4 4" />
            </g>
        </svg>
    )
}

export { Search }
